(() => {
  const formId = 'app-embed-container-1107109';
  const css = `
    :host {
      --forms-base-font-size: 12.6px !important;
      --forms-heading-font-size: 19.8px !important;
      --forms-body-font: normal 400 12.6px Helvetica, Arial, sans-serif !important;
      --forms-heading-font: normal 700 19.8px Helvetica, Arial, sans-serif !important;
      --heading-font-size: 19.8px !important;
      --forms-padding-top: 31.5px !important;
      --forms-padding-bottom: 31.5px !important;
      --forms-padding-left: 27px !important;
      --forms-padding-right: 27px !important;
      --form-field-padding: 13.5px !important;
      --button-padding: 13.5px !important;
      --container-max-w: 357.3px !important;
      --min-form-width: 0px !important;
    }
    [data-sizing="form-wrapper"] {
      --col-size: 288px !important;
      max-width: min(576px, calc(100vw - 32px)) !important;
      max-height: calc(100dvh - 32px) !important;
      overflow-y: auto !important;
    }
    [class*="formHeader"] { padding-inline: 20px !important; }
    [data-testid="btn-form-submit"] { background: var(--color-primary-button-background, #9D5A37) !important; color: #fff !important; border-color: var(--color-primary-button-background, #9D5A37) !important; }
    [data-testid="btn-form-submit"]:hover { background: var(--color-primary-button-hover-background, #874B2D) !important; }
    form[data-testid="form"] { gap: 10.8px !important; }
    [aria-label="Close modal"] { min-width: 44px !important; min-height: 44px !important; display: flex !important; align-items: center; justify-content: center; }
    @media (max-width: 1023px) {
      :host { --forms-body-font: normal 400 14px Helvetica, Arial, sans-serif !important; --forms-base-font-size: 14px !important; }
      [data-testid="btn-form-submit"] { min-height: 44px !important; box-sizing: border-box !important; }
      input { min-height: 44px !important; box-sizing: border-box !important; font-size: 16px !important; }
    }
    @media (max-width: 768px) {
      :host { --forms-padding-top: 22px !important; --forms-padding-bottom: 22px !important; --forms-padding-left: 20px !important; --forms-padding-right: 20px !important; --app-embed-padding-y: 12px !important; }
      [data-sizing="form-wrapper"] { width: min(357.3px, calc(100vw - 24px)) !important; grid-template-columns: minmax(0, 1fr) !important; grid-template-rows: auto !important; grid-template-areas: "content" !important; max-height: calc(100dvh - 24px) !important; }
      [data-sizing="form-wrapper"] > [class*="gridItem"][style*="background-image"] { display: none !important; }
      [class*="formDisclaimer"] { font-size: 11px !important; line-height: 1.45 !important; padding: 0 !important; }
    }
  `;
  const apply = () => {
    const root = document.getElementById(formId)?.shadowRoot;
    if (!root) return false;
    if (!root.querySelector('[data-erten-welcome-style]')) {
      const style = document.createElement('style');
      style.dataset.ertenWelcomeStyle = '';
      style.textContent = css;
      root.append(style);
    }
    return true;
  };
  if (apply()) return;
  const observer = new MutationObserver(() => { if (apply()) observer.disconnect(); });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
